import { z } from "zod";

import { UserStatus } from "@/enum";
import { UserLanguage } from "@/enum/user.enum";
import { FetchMeResponseSchema } from "@/pages/Public/pages/Login/schema/login";
import { ChipsListItemSchema } from "@/schemas/chips";
import { ERROR_TYPE } from "@/utils";

const { REQUIRED, INVALID_EMAIL } = ERROR_TYPE;

export const UserSchema = z.object({
	id: z.number().gt(0),
	firstName: z.string().min(1),
	lastName: z.string().min(1),
	email: z.string().email(INVALID_EMAIL),
	linkedinUrl: z.string().optional().nullable(),
	is2FAEnabled: z.boolean(),
	isBlocked: z.boolean(),
	status: z.nativeEnum(UserStatus),
	userlanguage: z.nativeEnum(UserLanguage).optional(),
	autoAccept: z.boolean().optional(),
	profileVisits: z.boolean().optional(),
	connectionScraping: z.boolean().optional(),
});

export const InviteRequestSchema = z.object({
	firstName: z.string().min(2, { message: REQUIRED }).trim(),
	lastName: z.string().min(2, { message: REQUIRED }).trim(),
	linkedinUrl: z.string().trim().optional(),
	email: z.string().email(INVALID_EMAIL),
	roles: z.array(z.string()).min(1, { message: REQUIRED }).max(1),
	/**
	 * Invite the user straight into a LinkedIn sending seat (PREC-3787). The API consumes a seat
	 * when this is true and rejects the invite with a 409 when the company has none left.
	 */
	linkedinAllowed: z.boolean(),
});

export const CustomerSchema = z.object({
	firstName: z.string().min(2, { message: REQUIRED }).trim(),
	lastName: z.string().min(2, { message: REQUIRED }).trim(),
	email: z.string().email(INVALID_EMAIL),
});

export const InviteFormSchema = InviteRequestSchema.omit({ roles: true }).extend({
	roles: ChipsListItemSchema.array().min(1, { message: REQUIRED }).max(1),
	companyId: z.number().optional(),
});

export const InviteResponseSchema = FetchMeResponseSchema.partial();

export type InviteRequest = z.infer<typeof InviteRequestSchema>;
export type InviteForm = z.infer<typeof InviteFormSchema>;
export type Customer = z.infer<typeof CustomerSchema>;
